import { IconButton, Tooltip } from "@mui/material";
import { Comment } from "@mui/icons-material";
import { CommentOutlined } from "@mui/icons-material";
import Messages from "../../../../localization/Messages";
import { useState } from "react";
import { useIntl } from "react-intl";
import RpisDialog from "../../../RpisDialog/RpisDialog";
import { BOOKING_REMARK_TYPE, BookingRemarkDialog } from "../BookingSidebarTitle";
import "./EditDispatcherRemark.css";
import { useSidebarOwner } from "../../../../contexts/SidebarOwnerContext";
import { IBooking } from "../../../../models/booking";

export type EditDispatcherRemarkProps = {
    onSubmit?: () => Promise<void>;
};

export function EditDispatcherRemark({ onSubmit = async () => {} }: EditDispatcherRemarkProps) {
    const [booking] = useSidebarOwner<IBooking>();
    const comment = booking?.comment;
    const bookingId = booking?.id;
    const intl = useIntl();
    const [open, setOpen] = useState(false);
    const dialogTitleSuffix = bookingId ? ` #${bookingId}` : "";
    const buttonTitleSuffix = comment ? `: ${comment}` : "";

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Tooltip
                key={comment}
                title={`${intl.formatMessage(Messages.editDispatcherRemark)}${buttonTitleSuffix}`}
            >
                <IconButton onClick={onOpen} className="comment-icon">
                    {comment ? <Comment /> : <CommentOutlined />}
                </IconButton>
            </Tooltip>
            <RpisDialog
                fullWidth
                size="sm"
                dialogOpen={open}
                title={`${intl.formatMessage(Messages.editDispatcherRemark)}${dialogTitleSuffix}`}
                onClose={onClose}
                content={
                    <BookingRemarkDialog
                        onClose={onClose}
                        reloadBookings={onSubmit}
                        remarkType={BOOKING_REMARK_TYPE.COMMENT}
                    />
                }
            />
        </>
    );
}
